import React, { useMemo } from 'react';
import Editor from 'src/components/Editor/Editor';
// Json Editor for json type KVS
const JsonEditorField = ({ data, onChangeField }) => {
  const valueStr = useMemo(() => {
    return typeof data?.value === 'string'
      ? data.value
      : JSON.stringify(data?.value ?? {}, null, 2);
  }, [data?.value]);

  return (
    <Editor
      mode="json"
      readOnly={false}
      wrapperStyle={{ height: '260px' }}
      value={valueStr}
      onChange={value =>
        onChangeField({ target: { name: data?.fld || '', value } })
      }
    />
  );
};

export default JsonEditorField;
